import { useCallback } from 'react';
import { useSearchParams } from '@direct-frontend/modules-router';
import {
    type InsufficientItem,
    useLoyaltyRegisterModalController,
    useModalController,
    useOrderSubmissionErrorModalController,
    useOutdatedStockModalController,
} from '@/shared/lib/hooks';
import { modalsService } from '@/shared/lib/modalsService';

export const useCheckoutModals = () => {
    const [searchParams] = useSearchParams();
    const stockChanged = searchParams.get('stockChanged') ?? false;

    const outdatedItemPrices = useModalController();
    const outdatedDeliveryPrices = useModalController();
    const outdatedStock = useOutdatedStockModalController();
    const minimumOrderAmountNotMet = useModalController();
    const promoCodeUsageLimitExceeded = useModalController();
    const invalidEmail = useModalController();
    const invalidPhone = useModalController();
    const orderSubmissionError = useOrderSubmissionErrorModalController();
    const payBoxModal = useModalController();
    const stockChangedModal = useModalController({
        dismissOnOutsideClick: false,
        initialOpen: Boolean(stockChanged),
        closable: false,
    });
    const outdatedLoyaltyConditions = useModalController();
    const loyaltyApplyError = useModalController();
    const invalidDeliveryFloor = useModalController();
    const onOzonRegistrationError = useModalController();
    const updateOrderFailure = useModalController({
        closable: false,
        dismissOnOutsideClick: false,
    });
    const loyaltyPromo = useModalController();
    const loyaltyRegister = useLoyaltyRegisterModalController();

    const onOutdatedStock = useCallback(
        (insufficientItems?: InsufficientItem[]) => {
            outdatedStock.setInsufficientItems(insufficientItems);
            outdatedStock.onOpen();
        },
        [outdatedStock]
    );

    modalsService.init({
        onOutdatedItemPrices: outdatedItemPrices.onOpen,
        onOutdatedDeliveryPrices: outdatedDeliveryPrices.onOpen,
        onMinimumOrderAmountNotMet: minimumOrderAmountNotMet.onOpen,
        onPromoCodeUsageLimitExceeded: promoCodeUsageLimitExceeded.onOpen,
        onInvalidEmail: invalidEmail.onOpen,
        onInvalidPhone: invalidPhone.onOpen,
        onSubmissionError: orderSubmissionError.onOpen,
        onPayBoxModal: payBoxModal.onOpen,
        onOutdatedStock,
        onOutdatedLoyaltyConditions: outdatedLoyaltyConditions.onOpen,
        onLoyaltyApplyError: loyaltyApplyError.onOpen,
        onInvalidDeliveryFloor: invalidDeliveryFloor.onOpen,
        onOzonRegistrationError: onOzonRegistrationError.onOpen,
        onUpdateOrderFailure: updateOrderFailure.onOpen,
        onLoyaltyPromo: loyaltyPromo.onOpen,
        onLoyaltyRegister: loyaltyRegister.onOpen,
    });

    return {
        modals: {
            outdatedItemPrices,
            outdatedDeliveryPrices,
            outdatedStock,
            minimumOrderAmountNotMet,
            promoCodeUsageLimitExceeded,
            invalidEmail,
            invalidPhone,
            orderSubmissionError,
            payBoxModal,
            stockChanged: stockChangedModal,
            outdatedLoyaltyConditions,
            loyaltyApplyError,
            invalidDeliveryFloor,
            onOzonRegistrationError,
            updateOrderFailure,
            loyaltyPromo,
            loyaltyRegister,
        },
    };
};
